import { firestore } from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import Auth, { InitializeCallback } from "@/app/api/Auth";
import Game from "@/app/api/Game";
import Purchases from "@/app/api/Purchases";
import { GameArgsType } from "@/types";

export type Snapshot = firestore.DocumentSnapshot<firestore.DocumentData>;
export type Data = firestore.DocumentData;
const auth = new Auth();

export default class Api {
  game?: Game;
  purchases?: Purchases;
  userId: string;
  _stats: { reads: number; deletes: number; writes: number };

  static Game = Game;

  constructor(userId: string) {
    this.userId = userId;
    this._stats = { reads: 0, deletes: 0, writes: 0 };
  }

  // global functions

  gameBoot(id: string) {
    if (!this.game) return;
    this._stats.writes++;
    this.game.boot(id);
  }

  gameDelete() {
    if (!this.game) return;
    this._stats.deletes++;
    return this.game.write(null);
  }

  gameLeave() {
    if (!this.game) return;
    this._stats.writes++;
    this.game.leave();
  }

  gameWrite(game: GameArgsType, options?: { merge: boolean }) {
    if (!this.game) return;
    this._stats.writes++;
    return this.game.write(game, options);
  }

  gameInitialize(gameId: string, onChange: (data?: Data) => void, onError: (error: Error) => void) {
    this.game = new Game(gameId, this.userId);
    this.game.doc.onSnapshot((snapshot: Snapshot) => {
      this._stats.reads++;
      onChange(snapshot.data());
    }, onError);
  }

  purchasesInitialize(onChange: (data?: Data) => void, onError: (error: Error) => void) {
    this.purchases = new Purchases(this.userId);
    this.purchases.doc.onSnapshot((snapshot: Snapshot) => {
      this._stats.reads++;
      onChange(snapshot.data());
    }, onError);
  }

  // Auth functions

  static initialize(callback: InitializeCallback) {
    return auth.initialize(callback);
  }

  static signInAnonymous() {
    return auth.signInAnonymous();
  }

  static signInGoogle() {
    return auth.signInGoogle();
  }

  static signOut() {
    return auth.signOut();
  }
}
